<script>
    import _            from 'lodash'
    import { navigate } from "svelte-routing"
    import * as api     from '../../shared/api.js'
    import EmailTo      from './EmailTo.svelte'
    import Logs         from './Logs.svelte'
    import Redo         from './Redo.svelte'
    import Result       from './Result.svelte'

    export let item
    export let status
    let action = null

    const lnk = `/empresa/${item.inquiry.domain.company}/pedidos/${item.inquiry.domain.domain}/pedido/${item.inquiry.protocol}/enviar/${status.place.identifier}?dm=${item.inquiry.domain.code}`

    function labelOf(it) {
        if(item.inquiry.status === 'REPORT SUCCESS' || item.inquiry.status === 'REPORT AVAILABLE')
            return "green"

        switch(it.status) {
            case "WAITING"   : return "";
            case "ERROR"     : return "red";
            case "EXECUTING" : return "";
            case "DONE"      : return "green";
            default          : return "";            
        }
    }

    function labelNameOf(it) {
        if(item.inquiry.status === 'REPORT SUCCESS' || item.inquiry.status === 'REPORT AVAILABLE')
            return "Terminado"

        switch(it.status) {
            case "WAITING"   : return "Aguardando";
            case "ERROR"     : return "Erro";
            case "EXECUTING" : return "Em execução";
            case "DONE"      : return "Terminado";
            default          : return it.status;            
        }
    }

    function logs(load) {
        // if(load) {
        //     console.log(`Loading LOGS`)
        // } else {
        //     console.log(`Unloading LOGS`)
        // }
    }

    function email(load) {
        // if(load) {
        //     console.log(`Loading EMAIL`)
        // } else {
        //     console.log(`Unloading EMAIL`)
        // }
    }

    function reply(load) {
        if(load) {
            navigate(lnk)
        } else {
        }
    }

    function perform(next) {

        const handlerFor = actionName => {
            switch(actionName) {
                case 'LOGS' : return logs
                case 'EMAIL': return email
                case 'REPLY': return reply
                default: return () => {}
            }
        }
        
        return function() {
            const handlePrev = handlerFor(action)
            const handleNext = handlerFor(next)
            if(action == next) {
                action = null
                handleNext(false)
            } else {
                action = next
                handlePrev(false)
                handleNext(true)
            }
        }
    }

    function activeConnector(status) {
        return _.head(status.place.connectors.filter(it => it.active))
    }

    function connectorInfo(connector) {        
        if(connector) {
            switch(connector.kind) {
                case 'api'           : return { icon: 'exchange'    , label: 'api'    }
                case 'gdrive-sheets' : return { icon: 'google drive', label: 'gdrive' }
                default              : return { icon: 'user'        , label: 'manual' } 
            }
        }
        return { icon: 'user', label: 'manual' }
    }

    $: disabled  = status.status === 'DONE' || item.inquiry.status === 'REPORT SUCCESS' || item.inquiry.status === 'REPORT AVAILABLE'
    $: active    = action !== null
    $: connector = activeConnector(status)
    $: info      = connectorInfo(connector)
</script>
<style>
    .sources {
        margin: 10px 0;
        padding: 10px;
        border: 1px solid red;
    }

    .source {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        /* border: 1px solid blue; */
        border-bottom: 1px solid #fafafa;
    }

    .source > div {
        margin: 8px;
        padding: 6px;
        /* border: 1px solid green; */
    }

    .source .status {
        width: 160px;
        align-self: center;
    }

    .source .name {
        align-self: center;
        flex: 1;
        font-weight: 700;
        font-size: 1em;
    }
    
    .details .item {
        transition: all .7s cubic-bezier(0, 1, 0.5, 1);
        overflow  : hidden;
    }

    .item.notHidden {
        opacity     : 1;
        /* max-height  : 1200px;
        overflow-y  : auto !important; */
    }

    .item.hidden {
        padding   : 0;
        opacity   : 0;
        max-height: 0px;
    }

    .frame {
        padding: 1em;
    }

    .connector {
        width: 100px;
    }
</style>

<div class="source">
    <div class="name">{ status.place.name }</div>
    <div class="connector">
        <div class="grey ui label">
            <i class="icon {info.icon}"></i> {info.label}
        </div>
    </div>
    <div class="status">
        <span class="ui large label { labelOf(status) }">{ labelNameOf(status) }</span>
    </div>
    <div class="actions">
        <div class="ui icon buttons">
            <button title="detalhes" 
                    class="ui large button" 
                    class:blue={ active && action === 'LOGS' }
                    on:click={ perform('LOGS') }>
                <i class="clipboard list icon"></i>
            </button>
            <button title="enviar email para responsável"
                    class="ui large button" 
                    class:blue={ active && action === 'EMAIL' }
                    on:click={ perform('EMAIL') }>
                <i class="envelope icon"></i>
            </button>
            <button title="responder manualmente" 
                    class="ui large button" 
                    class:blue={ active && action === 'REPLY' }
                    on:click={ perform('REPLY') }
                    class:disabled>
                <i class="pencil icon"></i>
            </button>
            <button title="resultado"
                    class="ui large button" 
                    class:blue={ active && action === 'RESULT' }
                    on:click={ perform('RESULT') } >
                <i class="database icon"></i>
            </button>
            <button title="refazer"
                    class="ui large button" 
                    class:blue={ active && action === 'REDO' }
                    on:click={ perform('REDO') }
                    class:disabled>
                <i class="redo icon"></i>
            </button>
        </div>
    </div>
</div>
<div class="details">
    <div class="item email" 
         class:notHidden = { action === 'EMAIL' } 
         class:hidden    = { action !== 'EMAIL' }>
        <div class="frame">
            <EmailTo {item} {status} active={ action === 'EMAIL' } />
        </div>
    </div>
    <div class="item logs"
         class:notHidden = { action === 'LOGS' } 
         class:hidden    = { action !== 'LOGS' }>
        <div class="frame">
            <Logs {item} {status} active={ action === 'LOGS' } />
        </div>
    </div>
    <div class="item redo"
         class:notHidden = { action === 'REDO' } 
         class:hidden    = { action !== 'REDO' }>
        <div class="frame">
            <Redo {item} {status} active={ action === 'REDO' } />
        </div>
    </div>
    <div class="item result"
         class:notHidden = { action === 'RESULT' } 
         class:hidden    = { action !== 'RESULT' }>
        <div class="frame">
            <Result {item} {status} active={ action === 'RESULT' } />
        </div>
    </div>
</div>
